import React from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { WhyChoose } from "../components/WhyChoose";
import { Portfolio } from "../components/Portfolio";
import { Process } from "../components/Process";
import { Testimonials } from "../components/Testimonials";
import { Industries } from "../components/Industries";
import { QuoteForm } from "../components/QuoteForm";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { FloatingButtons } from "../components/FloatingButtons";

export default function Landing() {
  return (
    <div className="bg-ink-900 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChoose />
        <Portfolio />
        <Process />
        <Testimonials />
        <Industries />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
